import React, { ReactNode } from "react";

import styles from "./external-matter-auto-complete-dropdown.module.css";
const { ["container"]: containerClassName, ["header"]: headerClassName } = styles as any;

type ExternalMatterAutoCompleteDropdownProps = {
  children?: ReactNode;
  externalMatterCount: number;
  pmsName: string;
};

export const ExternalMatterAutoCompleteDropdown: React.FC<ExternalMatterAutoCompleteDropdownProps> =
  ({ children, externalMatterCount, pmsName }) => (
    <div className={containerClassName}>
      <div>
        <div className={headerClassName}>
          <span>
            Select a {pmsName} Matter ({externalMatterCount})
          </span>
        </div>
      </div>
      <div>{children}</div>
    </div>
  );
